var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 36,
    viewBox: "875.25 253.308 31.5 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M906.75 278.62v-23.625c0-.935-.752-1.687-1.688-1.687H882a6.752 6.752 0 0 0-6.75 6.75v22.5a6.752 6.752 0 0 0 6.75 6.75h23.063c.935 0 1.687-.753 1.687-1.688v-1.125a1.7 1.7 0 0 0-.626-1.315c-.295-1.083-.295-4.17 0-5.252.38-.302.626-.78.626-1.308Zm-22.5-15.89c0-.233.19-.422.422-.422h14.906c.232 0 .422.19.422.421v1.407c0 .232-.19.422-.422.422h-14.906a.423.423 0 0 1-.422-.422v-1.407Zm0 4.5c0-.233.19-.422.422-.422h14.906c.232 0 .422.19.422.421v1.407c0 .232-.19.422-.422.422h-14.906a.423.423 0 0 1-.422-.422v-1.407Zm17.817 17.578H882a2.248 2.248 0 0 1-2.25-2.25 2.257 2.257 0 0 1 2.25-2.25h20.067c-.133 1.202-.133 3.297 0 4.5Z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Icon awesome-book"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/Books.e79b07d0743bdd028d313f6301bc6827.svg";
export { ForwardRef as ReactComponent };